module.exports = __webpack_public_path__ + "static/img/mobile-2.4e86834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile-2.png
// module id = 74
// module chunks = 2